
import { supabase } from "@/integrations/supabase/client";

export const verifyWebhookSetup = async (): Promise<{
  success: boolean;
  stripe_key_configured?: boolean;
  webhook_secret_configured?: boolean;
  message: string;
}> => {
  try {
    console.log("Verifying webhook configuration...");
    
    // Use supabase.functions.invoke instead of direct fetch to handle auth properly
    const { data, error } = await supabase.functions.invoke('stripe-webhook', {
      body: { verify: true }
    });
    
    if (error) {
      console.error("Error verifying webhook setup:", error);
      return {
        success: false,
        message: `Error checking webhook configuration: ${error.message}`
      };
    }
    
    console.log("Webhook verification response:", data);
    return {
      success: true,
      stripe_key_configured: data.stripe_key_configured,
      webhook_secret_configured: data.webhook_secret_configured,
      message: data.message || "Webhook verification successful"
    };
  } catch (err) {
    console.error("Exception in webhook verification:", err);
    return {
      success: false,
      message: `Exception during webhook verification: ${err instanceof Error ? err.message : String(err)}`
    };
  }
};

// Add a function to help users re-enable their webhook
export const createWebhookEnabledGuide = (): string => {
  return `
If your webhook has been disabled by Stripe, follow these steps to re-enable it:

1. Log in to your Stripe Dashboard: https://dashboard.stripe.com/
2. Go to Developers > Webhooks
3. Find your disabled webhook endpoint (https://iaydpqbgutssogjfqygl.supabase.co/functions/v1/stripe-webhook)
4. Click on the webhook, then click the "Enable" button
5. Test your webhook by clicking "Send test webhook" to verify it's working correctly

After re-enabling, your webhook should start receiving events again.
`;
};
